<template>
  <div class="flex flex-col mo:justify-between w-screen h-auto md:h-screen">
    <div class="c-spinner" v-if="!preloadComplete" />
    <transition name="fade" appear>
      <site-header />
    </transition>
    <main class="main w-full h-full" :class="{ 'loaded': preloadComplete}">
      <transition name="fade" appear>
        <Overlay v-if="overlayVisible" ref="overlay" @overlay-close="this.onOverlayClose" />
      </transition>
      <transition
        name="fade"
        mode="out-in"
        appear>
        <keep-alive>
          <component :is="currentModule" v-if="preloadComplete" @section-selected="this.showOverlay" />
        </keep-alive>
      </transition>
    </main>
    <transition name="fade" appear>
      <site-footer />
    </transition>
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter'
import Intro from '@/components/Intro'
import LogoWall from '@/components/LogoWall'
import Overlay from '@/components/Overlay'
import content from '../content'
import axios from 'axios'
import imagesLoaded from 'imagesloaded'
import { mapState } from 'vuex'

const modules = [Intro, LogoWall]

export default {

  data() {
    return {
      preloadComplete: false,
      overlayVisible: false,
    }
  },
  components: {
    Overlay,
    Intro,
    LogoWall,
    SiteFooter,
  },
  computed: {
    ...mapState(['activeSectionId']),
    currentModule() {
      return modules[this.activeSectionId]
    }
  },
  mounted() {
    axios
      .get('/api/content.json')
      .then(response => {
        content.data = response.data.data[0]
        this.preloadImageAssets()
      })
      .catch(function() {
        // console.log('Error while loading content!', error)
      })
  },
  methods: {
    preloadImageAssets() {
      let preloadImages = []
      for (let i = 0; i < content.data.companies.length; i++) {
        const item = content.data.companies[i]
        const image = new Image()
        const mobileImage = new Image()
        image.src = item.image
        mobileImage.src = item.mobileImage
        preloadImages.push(image)
        preloadImages.push(mobileImage)
      }

      content.data.members.forEach(element => {
        preloadImages.push(element.image)
        preloadImages.push(element.mobileImage)  
      });
     
      const imgLoad = imagesLoaded(preloadImages)
      imgLoad.on('done', () => {
        this.preloadComplete = true;
      })
    },
    showOverlay() {
      this.overlayVisible = true
      window.scrollTo({ top: 0, behavior: 'smooth'})
      this.$store.commit('setActiveSectionId', null)

    },
    onOverlayClose() {
      this.overlayVisible = false
      this.$store.commit('setActiveSectionId', 1)
    },
  },
}
</script>

<style lang="stylus">
#app
  min-height 100vh
  min-height calc((var(--vh, 1vh) * 100))
.main
  max-height 70%
.c-spinner
  width 32px
  height 32px
  animation rotate 0.8s infinite linear
  border 8px solid #04345a
  border-right-color transparent
  border-radius 50%
  opacity 0.8
  z-index 1
  position absolute
  top calc(50% - 16px)
  left calc(50% - 16px)

@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)

</style>
